angular
  .module('resources.AdminCategory', ['ngResource'])
  .factory('AdminCategory', ['$resource', function ($resource) {
    var Resource = $resource('/api/admin/categories/:id', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false
      },
      update: {
        method: 'PUT',
        isArray: false
      },
      getTree: {
        method: 'GET',
        url: '/api/admin/categoriesTree',
        isArray: true
      }
    });

    return Resource;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/AdminCategory.js